export default __webpack_public_path__ + "static/media/auditif.0af1412e.svg";